module.exports = __webpack_public_path__ + "img/DENTINO.101f92c2.png";